export const emptyForm = {
    firstName: '',
    lastName: '',
    email: '',
    company: '',
    phone: '',
    howCanWeHelp: '',
    howDidYouHearAboutUs: ''
  }